{
    "coordinates": [
        -19.859708348935214,
        44.502000607375834
    ],
    "tooltip": "Holocene Madagascar",
    "title": "Holocene Madagascar",
    "country": "Madagascar",
    "period": "Quaternary",
    "alt": "TODO"
}
